module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_5_2_drag_2.4cb55928.png";